
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { ROUTES } from '@router'

export default {
  components: {
    SkinnyBanner: () => import('@core/components/SkinnyBanner'),
  },

  props: {
    activeGrade: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters({
      isSkinnyBannerAvailable: 'countryConfig/isSkinnyBannerAvailable',
    }),

    skinnyBannerId() {
      return this.activeGrade.skinnyBannerId
    },

    hasSellerBanner() {
      return (
        this.skinnyBannerId !== null &&
        this.isSkinnyBannerAvailable('product-merchant', this.skinnyBannerId)
      )
    },

    hasProductBanner() {
      return this.isSkinnyBannerAvailable(ROUTES.PRODUCT.HOME)
    },

    skinnyBanner() {
      if (this.hasSellerBanner) {
        return {
          page: 'product-merchant',
          id: this.skinnyBannerId,
        }
      }

      if (this.hasProductBanner) {
        return {
          page: ROUTES.PRODUCT.HOME,
        }
      }

      return {}
    },

    hasSkinnyBanner() {
      return !isEmpty(this.skinnyBanner)
    },
  },
}
